"use strict";
export const LEGAL_URLS = {
  privacyPolicy: "https://triumph.io/privacy-policy/",
  noticeAtCollection: "https://triumph.io/privacy-policy/#notice",
  smsTermsOfService: "https://triumph.io/sms-terms/",
  termsOfService: "https://triumph.io/terms-of-service/"
};
